import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["body", "footer"]

  connect() {
    this.boundSync = this.sync.bind(this)

    if (this.hasBodyTarget) {
      this.bodyTarget.addEventListener("scroll", this.boundSync)
      this.resizeObserver = new ResizeObserver(this.boundSync)
      this.resizeObserver.observe(this.bodyTarget)
    }

    this.sync()
  }

  disconnect() {
    if (this.hasBodyTarget) {
      this.bodyTarget.removeEventListener("scroll", this.boundSync)
    }

    this.resizeObserver?.disconnect()
  }

  sync() {
    if (!this.hasBodyTarget || !this.footerTargets.length) return

    const body = this.bodyTarget
    const show = body.offsetHeight > 0 &&
      body.scrollHeight > body.clientHeight &&
      body.scrollHeight - body.scrollTop - body.clientHeight >= 1

    this.footerTargets.forEach((footer) => {
      footer.classList.toggle("shadow-top", show)
    })
  }
}
